import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const HomeServices = createApi({
	reducerPath: "homeContent",
	baseQuery: fetchBaseQuery({
		baseUrl: "https://flit-backend.developer-ourbase-camp.com/api/",
	}),
	endpoints: (builder) => {
		return {
			homeContent: builder.query({
				query: () => {
					return {
						url: "pages/home",
						method: "GET",
					};
				},
			}),
			siteSettings: builder.query({
				query: () => {
					return {
						url: "/settings",
						method: "GET",
					};
				},
			}),
		};
	},
});
export const { useHomeContentQuery, useSiteSettingsQuery } = HomeServices;
export default HomeServices;
